import { combineReducers } from "@reduxjs/toolkit";
import adminAuthReducer from "../features/adminAuth/slices/adminAuth.slice";
import adminUsersReducer from "../features/admin/slices/adminUsers.slice";
import adminProductsReducer from "../features/admin/slices/adminProducts.slice";
import adminRequestsReducer from "../features/admin/slices/adminRequests.slice";

const rootReducer = combineReducers({
  adminAuth: adminAuthReducer,
  adminUsers: adminUsersReducer,
  adminProducts: adminProductsReducer,
  adminRequests: adminRequestsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
